import { StateCreator } from 'zustand';

type DownloadState = {
    [id: string]: {
        progress: number;
        loading: boolean;
    };
};

export interface DownloadCsvStreamSlice {
    streamDownloads: DownloadState;
    setDownload: (id: string, progress: number, loading: boolean) => void;
    resetDownload: (id: string) => void;
    resetAllDownloads: () => void;
}
export const createDownloadCsvStreamSlice: StateCreator<DownloadCsvStreamSlice, [], [], DownloadCsvStreamSlice> = (
    set
) => ({
    streamDownloads: {},
    setDownload: (id: string, progress: number, loading: boolean) =>
        set((state) => ({
            streamDownloads: {
                ...state.streamDownloads,
                [id]: { progress, loading }
            }
        })),
    resetDownload: (id) =>
        set((state) => ({
            streamDownloads: {
                ...state.streamDownloads,
                [id]: {
                    progress: 0,
                    loading: false
                }
            }
        })),
    resetAllDownloads: () =>
        set({
            streamDownloads: {}
        })
});
